<script>
import api from '@utils/api'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'GoodsInfo',
  props: {
    goods: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        shortName: null,
        fullName: null,
        status: null,
        description: null,
        employer: null,
        group: null,
        articleNumber: null,
      },
      rules: {
        shortName: [x => !!x || this.$t('validation__is_required')],
        fullName: [x => !!x || this.$t('validation__is_required')],
        status: [x => !!x || this.$t('validation__is_required')],
        group: [x => !!x || this.$t('validation__is_required')],
        articleNumber: [x => !!x || this.$t('validation__is_required')],
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
    }
  },
  computed: {
    isInactive() {
      return this.goods.status === 2
    },
    isArticleRequired() {
      return this.item.group === 6
    },
    status() {
      return this.$store.getters['data/getDictionary']('goodsstatus')
      .map(item => {
        item.translatedStatus = this.$t(`goodsstatus.${item.code}.name`)
        return item
      })
    },
    employer() {
      return this.$store.getters['data/getOrganization']
    },
    group() {
      return this.$store.getters['data/getDictionary']('goodsgroup')
      .map(item => {
        item.translatedGroup = this.$t(`goodsgroup.${item.code}.name`)
        return item
      })
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  created() {
    Object.assign(this.item, this.goods) // Клонируем пропсы в стейт
  },
  methods: {
    close() {
      this.$router.push('/dictionaries/goods')
    },
    updateGoods() {
      if (this.$refs.goodsForm.validate()) {
        this.loading = true
        api
          .updateGoods(this.item)
          .then(response => {
            this.loading = false
            this.$store.dispatch('data/updateDictionary', 'goods')
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex lg4>
        <v-form 
          ref="goodsForm" 
          v-model="valid" 
          lazy-validation>
          <v-text-field
            :label="$t('label__short_name')"
            v-model="item.shortName"
            :readonly="isInactive || !userAllowedToUpdate"
            :rules="rules.shortName"
            name="shortName"
            autocomplete="off"
          />
          <v-text-field
            :label="$t('label__full_name')"
            v-model="item.fullName"
            :readonly="isInactive || !userAllowedToUpdate"
            :rules="rules.fullName"
            name="fullName"
            autocomplete="off"
          />
          <v-select
            :items="status"
            :label="$t('label__status')"
            :readonly="!userAllowedToUpdate"
            v-model="item.status"
            :rules="rules.status"
            item-text="translatedStatus"
            item-value="code"
          />
          <v-text-field
            :label="$t('label__description')"
            v-model="item.description"
            :readonly="isInactive || !userAllowedToUpdate"
            name="description"
            autocomplete="off"
          />
          <v-select
            :items="employer"
            :label="$t('label__employer')"
            v-model="item.employer"
            :readonly="isInactive || !userAllowedToUpdate"
            :no-data-text="$t('label__no_data_available')"
            item-text="shortName"
            item-value="id"
            autocomplete
          />
          <v-select
            :items="group"
            :label="$t('label__group')"
            :readonly="!userAllowedToUpdate"
            v-model="item.group"
            :rules="rules.group"
            :no-data-text="$t('label__no_data_available')"
            item-text="translatedGroup"
            item-value="code"
            autocomplete
            disabled
          />
          <v-text-field
            :label="$t('label__article_number')"
            :readonly="!userAllowedToUpdate"
            v-model="item.articleNumber"
            :required="isArticleRequired"
            :rules="isArticleRequired ? rules.articleNumber : []"
            name="articleNumber"
            autocomplete="off"
          />
        </v-form>
        <small>* {{ $t('label__requier_small_text') }}</small>
        <div :class="$style.btnWrapper">
          <v-btn
            v-if="!isInactive && userAllowedToUpdate"
            :loading="loading"
            :disabled="loading"
            color="success"
            @click="updateGoods"
          >
            {{ $t('buttons__update') }}
          </v-btn>
          <v-btn 
            color="secondary" 
            @click="close">
            {{ $t('buttons__close') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
